module.exports = __webpack_public_path__ + "static/media/proj15_img3.8a9e30dc.jpg";